import React from 'react';
import ReactDOM from 'react-dom/client';
import P2PVisualizer from './P2PVisualizer';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <P2PVisualizer />
  </React.StrictMode>
);
